import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';
import Builder from 'partials/Builder';
import css from 'css';

import { redirect404, checkResourcePath, gtmPush, decodeHtml } from 'helpers';
import Header from 'partials/Header';
import Footer from 'partials/Footer';
import ErrorBoundary from 'partials/ErrorBoundary';
import NotFound from 'partials/NotFound'

class BlogPost extends Component {

    constructor() {
        super();

        this.state = {
			notFound: false,
            blogPost: null
        }
    }

	componentDidMount() {
		this._load_blogpost_data_from_api();
	}

	_load_blogpost_data_from_api = () => {
		api.getBlogBySlug({ slug: this.props.match.params.slug })
            .then(resp => {

                if(!resp.data[0]) {
                    this.setState({ notFound: true })
                }
                this.setState({ blogPost: resp.data[0] });
            })
            .catch(e => console.log(e));

	}


	render() {
        const { blogPost } = this.state;

        const pageBackground = blogPost && blogPost.acf && blogPost.acf.page_background ? blogPost.acf.page_background : 'white';

        const modules =  blogPost && blogPost.acf && blogPost.acf.modules ? blogPost.acf.modules : [];

		if(this.state.notFound) return <NotFound/>

        if(!blogPost) return null

		return(
			<Wrapper pageBackground={pageBackground}>
				<Header />
				<Container>
					<div className="row">
						<ContentWrapper>
							<Builder data={modules || []} page={blogPost}  />
						</ContentWrapper>
					</div>
				</Container>
                <ErrorBoundary for="Footer">
                    <Footer/>
                </ErrorBoundary>
			</Wrapper>
		);
	}

}

const mapStateToProps = (state, props) => ({
    page: state.pages[props.match.params.slug] || null
});

const actions = {
}

export default connect(mapStateToProps, actions)(withRouter(BlogPost));

const Wrapper = styled.div`
    display:block;
    position:relative;
    width:100%;

    background: ${props => css.colors[props.pageBackground]};
`

const Container = styled.div`
	font-family: Helvetica;
	position: relative;
	min-height: 100vh;
	max-width: 1260px;
	width: 100%;
	margin-left: auto;
	margin-right: auto;

	.row {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: center;
	}
`;



const ContentWrapper = styled.div`
	position: relative;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	max-width: 980px;
	width: 100%;
`;


// WEBPACK FOOTER //
// ./src/views/BlogPost.js